import React, {useState} from 'react';
import {Accordion} from '../../Accordion/Accordion';
import {ContentWrapper} from './FileMetaDataTabLocales.style';
import {t} from 'i18next';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import {AdvancedLocalePicker} from '../../LocalePicker/AdvancedLocalePicker';
import {Label} from '../../../models/Label';
import cloneDeep from 'lodash/cloneDeep';
import EventEmitter from 'events';
import {getLabelMapKeys} from '../../../utils/StorageObjectUtils';
import {
    FileMetaDataDialog_changeLabels,
    FileMetaDataDialog_changeLocales,
    FileMetaDataTabLocales_changeLocales,
    FileMetaDataTabMain_changeLabels
} from '../../../init/events';
import {TemplatePropertySettings} from '../../../models/TemplatePropertySettings';
import {isVisibleComponent} from '../../../utils/TemplateUtils';
import {STORAGE_OBJECT_OBJECT_LABELS} from '../../../init/storage_object_constants';

export interface FileMetaDataTabLocalesProps {
    readonly templatePropertySettings: Map<string, TemplatePropertySettings>;
    readonly labels: Map<string, Label>;
    readonly parentLocales: string[];
    readonly defaultLocale: string;
    readonly labelsInitialState: Map<string, Label>;
    readonly eventEmitter: EventEmitter;
}

/**
 * @name FileMetaDataTabLocales
 * @description
 * The dialog to add the metadata of a newly created file or edited file - Metadata Tabs
 */
export const FileMetaDataTabLocales: React.VFC<FileMetaDataTabLocalesProps> = (props) => {
    const [localesInput, setLocalesInput] = useState<string[]>(getLabelMapKeys(props.defaultLocale, props.labels));
    const [parentLocalesInput] = useState(props.parentLocales ?? []);

    const handleChangeLocalesState = (locales: string[]) => {
        setLocalesInput(locales);
    };

    const handleChangeLocales = (locales: string[]) => {
        setLocalesInput(locales);
        props.eventEmitter.emit(FileMetaDataDialog_changeLocales, locales);
    };

    const handleResetLocales = () => {
        let labels = cloneDeep(props.labelsInitialState);
        let locales = getLabelMapKeys(props.defaultLocale, labels);
        props.eventEmitter.emit(FileMetaDataTabMain_changeLabels, labels);
        handleChangeLocales(locales);
        props.eventEmitter.emit(FileMetaDataDialog_changeLabels, labels);
    };

    props.eventEmitter.on(FileMetaDataTabLocales_changeLocales, handleChangeLocalesState);

    return (
        <ContentWrapper id={generateIdentifier()}>
            {isVisibleComponent(STORAGE_OBJECT_OBJECT_LABELS, props.templatePropertySettings) &&
                <Accordion accordionHeadline={t('LOCALE_CAPTION')}
                           startOpen>
                    <AdvancedLocalePicker defaultLocale={props.defaultLocale}
                                          locales={localesInput}
                                          parentLocales={parentLocalesInput}
                                          setParentLocales={false}
                                          eventEmitter={props.eventEmitter}
                                          onChange={handleChangeLocales}
                                          onReset={handleResetLocales}/>
                </Accordion>
            }
        </ContentWrapper>
    );
}